import { CardDetails } from "./types/add-to-wallet";

/** Dev/mock card payload shown when Elektra is unavailable. */
export const MOCK_WALLET_CARD_DETAILS: CardDetails = {
	cardNumber: "4532 1234 5678 9010",
	expirationDate: "12/28",
	cvv: "123",
};
